import { useNavigate } from "react-router";
import useThemeHook from "../hooks/useThemeHook";
import { THEME_COLORS } from "../themes/DarkLight";
import "./CommonNavBar.css";
import { isNotNullOrUndefined } from "../utils/isNotNullOrUndefined";
import { useState, useEffect } from "react";
import { debounce } from "../utils/debounce";
import isRunningOnMobile from "../utils/isRunningOnMobile";
function CommonNavBar({
  title,
  button,
  disableBackButton,
}: {
  title?: string;
  button?: any;
  disableBackButton?: boolean;
}) {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (isNotNullOrUndefined(disableBackButton) && disableBackButton === true) {
      return;
    }
    navigate(-1);
  };
  const theme = useThemeHook();
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);

  const handleScroll = debounce(() => {
    const currentScrollPos = window.pageYOffset;
    setVisible(
      (prevScrollPos > currentScrollPos &&
        prevScrollPos - currentScrollPos > 70) ||
        currentScrollPos < 10 ||
        currentScrollPos < prevScrollPos
    );

    setPrevScrollPos(currentScrollPos);
  }, 200);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [prevScrollPos, visible, handleScroll]);
  return (
    <>
      <div
        style={{
          position: isRunningOnMobile() ? "absolute" : undefined,
          left: 0,
          right: 0,
          paddingRight: "10px",
          paddingLeft: "10px",
          top: visible ? "0" : "-60px",
          backgroundColor: THEME_COLORS[theme].full_theme,
          color: THEME_COLORS[theme].inverse_theme,
          alignItems: "center",
          justifyContent: "center",
        }}
        className="LoginFirstText navbar"
      >
        {true && (
          <svg
            onClick={() => handleBackClick()}
            xmlns="http://www.w3.org/2000/svg"
            width={"25"}
            height={"25"}
            fill={"currentColor"}
            className="bi bi-chevron-left"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
            />
          </svg>
        )}
        <p style={{ fontWeight: "500", width: "100%", textAlign: "start" }}>
          {title}
        </p>
        {isNotNullOrUndefined(button) && button}
      </div>
      <div style={{ minHeight: "55px" }}></div>
    </>
  );
}

export default CommonNavBar;
